const KEY_TILES = {
  generalData: {
    code: 'osnovno',
    pib: 'osnovno',
    apiKey: 'efakture',
    mainCompany: 'osnovno',
    default: 'kontakt',
  },
  applicationSettings: {
    typeOfCompany: 'osnovno',
    eInvoice: 'efakture',
    qrInEInvoices: 'efakture',
    invoiceProjectEnabled: 'efakture',
    manualPurchaseInvoiceEnabled: 'efakture',
    invoiceJournalEnabled: 'efakture',
    salesJournalEnabled: 'efakture',
    vatNoticeEnabled: 'efakture',
    advancedSalesInvoicingEnabled: 'efakture',
    autoArchiveInvoicesEnabled: 'efakture',
    manualArchiveInvoicesEnabled: 'efakture',
    postedToErpTrackingEnabled: 'efakture',
    taxReturnsClientView: 'efakture',
    ledgerCardsEnabled: 'efakture',
    sefCustomsEnabled: 'efakture',
    sefInputVatEnabled: 'efakture',
    sefVatRecordingEnabled: 'efakture',
    sefFiscalBillsEnabled: 'efakture',
    showInternalRefNumber: 'efakture',
    timeTracking: 'vreme',
    timesheetReview: 'vreme',
    toolsEnabled: 'moduli',
    calculatorEnabled: 'moduli',
    assistantEnabled: 'moduli',
    salaryTileEnabled: 'moduli',
    activityFeedEnabled: 'moduli',
    mfaEnabled: 'pristup',
    ssoOnly: 'pristup',
    ssoTenantId: 'pristup',
    ssoAllowedDomains: 'pristup',
    isGrossBonus: 'bonus',
    default: 'hr',
  },
  calculationSettings: {
    workTypes: 'obracun',
    overTime2: 'obracun',
    extendedAbExport: 'obracun',
    default: 'bonus',
  },
};

const GROUP_TILES = {
  name: 'osnovno',
  market: 'osnovno',
  timeTrackingSettings: 'vreme',
  loyaltyHolidaySettings: 'hr',
  clientsAdmins: 'pristup',
  ownershipStructure: 'vlasnistvo',
  authorizedRepresentatives: 'vlasnistvo',
  allowances: 'naknade',
  currencies: 'naknade',
  salaryCalculationSettings: 'obracun',
  otherAllowances: 'bonus',
  bonusVariations: 'bonus',
  suspensionVariations: 'bonus',
  nonMonetaryBenefitVariations: 'bonus',
  // Keys of the server's permission map that are not form paths as such.
  emailReceivers: 'kontakt',
  separatedRequestDocs: 'hr',
  companyAdminReceiveHREmails: 'hr',
  companyDocsSettings: 'sabloni',
  calculationMethodMeal: 'naknade',
  mealCurrency: 'naknade',
  calculationMethodHoliday: 'naknade',
  holidayCurrency: 'naknade',
  travelExpCurrency: 'naknade',
  otherIncomeCurrency: 'bonus',
  otherExpensesCurrency: 'bonus',
  suspensionCurrency: 'bonus',
  bonusCurrency: 'bonus',
  nonMonetaryBenefitCurrency: 'bonus',
};

// Permission map keys no profile tile shows.
const OFF_PROFILE_KEYS = ['companyLogo', 'recipient', 'travelExpenses'];

/**
 * Which company profile tile holds a form field — to open the tile of the
 * first field that failed validation and to mark tiles with unsaved changes.
 *
 * @param {Array<string|number>} name - Form name path
 * @returns {string} Tile id
 */
export const companySectionOfField = (name = []) => {
  const [group, key] = name;
  // Some fields are registered under a dotted string name.
  const [dottedGroup, dottedKey] = String(group).split('.');
  const g = KEY_TILES[group] ? group : dottedGroup;
  const k = KEY_TILES[group] ? key : dottedKey || key;
  if (KEY_TILES[g]) return KEY_TILES[g][k] || KEY_TILES[g].default;
  return GROUP_TILES[group] || GROUP_TILES[dottedGroup] || 'osnovno';
};

/**
 * Tile of a key of the server's permission map; null when no tile shows it.
 *
 * @param {string[]} name - Permission map key split on dots
 * @returns {string|null}
 */
export const companyTileOfPermission = (name = []) =>
  OFF_PROFILE_KEYS.includes(name[0]) ? null : companySectionOfField(name);

// Tiles of the company profile whose content is (partly) the company form.
export const COMPANY_PROFILE_FORM_SECTIONS = [
  'osnovno',
  'kontakt',
  'hr',
  'efakture',
  'vreme',
  'moduli',
  'pristup',
  'naknade',
  'obracun',
  'bonus',
  'vlasnistvo',
];
